import { Text, View } from "@react-pdf/renderer";
import { formatDateTime } from "../../../../utils/date_formatter";
import { convertSnakeCaseToTitleCase } from "../../../../utils/string_convert_helper";
import { styles } from "../../ReactPdfStyles";

type IncidentDetailSectionTypes = {
	data: Record<string, any>;
	renderFiles: () => React.ReactNode;
};

export function IncidentDetailSection({
	data,
	renderFiles,
}: IncidentDetailSectionTypes) {
	return (
		<View style={[styles.section, styles.tableFontSize]}>
			<Text style={styles.tableHeader}>Incident detail</Text>

			<View style={styles.row}>
				<Text style={styles.labelCell}>Date and time of incident</Text>
				<Text style={styles.valueCell}>{formatDateTime(data.date_time)}</Text>
				<Text style={styles.labelCell}>Department</Text>
				<Text style={[styles.valueCell, styles.borderRight]}>
					{data.department_name}
				</Text>
			</View>
			<View style={styles.row}>
				<Text style={styles.labelCell}>Incident type</Text>
				<Text style={styles.valueCell}>
					{convertSnakeCaseToTitleCase(data.incident_type ?? "")}
				</Text>
				<Text style={styles.labelCell}>Companies involved</Text>
				<Text style={[styles.valueCell, styles.borderRight]}>
					{data.companies_involved}
				</Text>
			</View>

			<View style={styles.row}>
				<Text style={styles.labelCell}>Incident description</Text>
				<Text style={[styles.valueCell, styles.borderRight]}>
					{data.description}
				</Text>
			</View>

			<View style={styles.row}>
				<Text style={styles.labelCell}>File upload(s)</Text>
				<View style={[styles.valueCell, styles.borderRight]}>
					{renderFiles()}
				</View>
			</View>

			<View style={styles.row}>
				<Text style={styles.labelCell}>Investigation</Text>
				<Text style={[styles.valueCell, styles.borderRight]}>
					{data.investigation}
				</Text>
			</View>
		</View>
	);
}

export default IncidentDetailSection;
